// extracted by mini-css-extract-plugin
var _1 = "mkH9c";
export { _1 as "base" }
